// extracted by mini-css-extract-plugin
export var actions = "_ld-g";
export var benefitCard = "_ld-b";
export var benefitIcon = "_ld-d";
export var benefitLabel = "_ld-f";
export var benefits = "_ld-a";
export var benefitsSection = "_ld-8";
export var bodyText = "_ld-7";
export var closeButton = "_ld-2";
export var content = "_ld-3";
export var eyebrow = "_ld-4";
export var heading = "_ld-5";
export var image = "_ld-i";
export var imagePanel = "_ld-h";
export var modal = "_ld-0";
export var offerCard = "_ld-c";
export var offerIcon = "_ld-e";
export var sectionLabel = "_ld-9";
export var shell = "_ld-1";
export var title = "_ld-6";